import { Link } from "react-router-dom";

const quickEntries = [
  {
    key: "movie",
    name: "电影",
    desc: "院线新片与口碑佳作",
    to: "/category/movie",
    icon: "ri-film-line",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%20editorial%20card%20image%20of%20a%20warm%20lit%20cinema%20screen%20and%20seats%20seen%20from%20behind%2C%20soft%20orange%20and%20grey%20tones%2C%20clean%20simple%20background%2C%20cozy%20atmosphere%2C%20minimal%20flat%20composition%2C%20high%20quality&width=600&height=400&seq=pcm-qe-movie&orientation=landscape",
  },
  {
    key: "tv",
    name: "电视剧",
    desc: "热播剧集与补番指南",
    to: "/category/tv",
    icon: "ri-tv-2-line",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%20editorial%20card%20image%20of%20a%20cozy%20evening%20living%20room%20with%20a%20glowing%20tv%20screen%2C%20soft%20orange%20and%20warm%20grey%20tones%2C%20clean%20simple%20background%2C%20comfortable%20atmosphere%2C%20minimal%20flat%20composition%2C%20high%20quality&width=600&height=400&seq=pcm-qe-tv&orientation=landscape",
  },
  {
    key: "star-news",
    name: "明星动态",
    desc: "采访、活动与片场花絮",
    to: "/star-news",
    icon: "ri-user-star-line",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%20editorial%20card%20image%20of%20a%20warm%20stage%20spotlight%20and%20an%20empty%20director%20chair%2C%20soft%20orange%20and%20grey%20tones%2C%20clean%20simple%20background%2C%20elegant%20atmosphere%2C%20minimal%20flat%20composition%2C%20high%20quality&width=600&height=400&seq=pcm-qe-star&orientation=landscape",
  },
  {
    key: "special",
    name: "精选专题",
    desc: "按主题深度逛影视",
    to: "/special/sp-01",
    icon: "ri-bookmark-3-line",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%20editorial%20card%20image%20of%20a%20curated%20shelf%20of%20stacked%20film%20reels%20and%20booklets%20in%20warm%20light%2C%20soft%20orange%20and%20grey%20tones%2C%20clean%20simple%20background%2C%20orderly%20atmosphere%2C%20minimal%20flat%20composition%2C%20high%20quality&width=600&height=400&seq=pcm-qe-special&orientation=landscape",
  },
];

export default function QuickEntries() {
  return (
    <section aria-label="分类快捷入口">
      <div className="mb-5 flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
          <i className="ri-apps-2-line text-xl"></i>
        </span>
        <div>
          <h2 className="font-heading text-lg font-black text-foreground-950 md:text-xl">
            分类快捷入口
          </h2>
          <p className="mt-1 text-xs text-foreground-500 md:text-sm">按兴趣直达你想看的内容</p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {quickEntries.map((entry) => (
          <Link
            key={entry.key}
            to={entry.to}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-200 hover:border-primary-300"
          >
            <div className="relative h-32 w-full overflow-hidden bg-background-100">
              <img
                src={entry.image}
                alt={`${entry.name}入口配图`}
                title={`${entry.name}快捷入口`}
                className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 to-transparent"></div>
              <span className="absolute bottom-3 left-3 flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${entry.icon} text-lg`}></i>
              </span>
            </div>
            <div className="flex flex-1 items-center justify-between p-4">
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                  {entry.name}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">{entry.desc}</p>
              </div>
              <i className="ri-arrow-right-line text-lg text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-600"></i>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}